import { RuntimeExamModeScreen } from '@/features/unified-learning/runtime/screens/RuntimeExamModeScreen';

export default function LearnExamModeRoute() {
  return <RuntimeExamModeScreen runtimeBase="/learn/path" />;
}
